/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointMap } from './DataPointMap';
import {
    DataPointMapFromJSON,
    DataPointMapFromJSONTyped,
    DataPointMapToJSON,
    DataPointMapToJSONTyped,
} from './DataPointMap';

/**
 * 
 * @export
 * @interface PaginatedDataPointMapList
 */
export interface PaginatedDataPointMapList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataPointMapList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDataPointMapList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DataPointMap>}
     * @memberof PaginatedDataPointMapList
     */
    results: Array<DataPointMap>;
}

/**
 * Check if a given object implements the PaginatedDataPointMapList interface.
 */
export function instanceOfPaginatedDataPointMapList(value: object): value is PaginatedDataPointMapList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDataPointMapListFromJSON(json: any): PaginatedDataPointMapList {
    return PaginatedDataPointMapListFromJSONTyped(json, false);
}

export function PaginatedDataPointMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDataPointMapList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(DataPointMapFromJSON)),
    };
}

export function PaginatedDataPointMapListToJSON(json: any): PaginatedDataPointMapList {
    return PaginatedDataPointMapListToJSONTyped(json, false);
}

export function PaginatedDataPointMapListToJSONTyped(value?: PaginatedDataPointMapList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DataPointMapToJSON)),
    };
}

